import type { URLOpenListenerEvent } from '@capacitor/app';
import { App } from '@capacitor/app';
import type React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const AppUrlListener: React.FC<any> = () => {
  const history = useHistory();

  useEffect(() => {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      const slug = event.url.split('hyprism.com').pop();
      if (slug) {
        history.push(slug);
      }
      // If no match, do nothing - let regular routing
      // logic take over
    });
  }, []);

  return null;
};

export default AppUrlListener;
